import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation } from "react-router-dom";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { status, user, error } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
 

  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
  document.documentElement.style.setProperty('--panel-color', theme.panel_color || '#fffbdd');
  document.documentElement.style.setProperty('--center-panel-color', theme.center_panel_color || '#ffffff');
  document.documentElement.style.setProperty('--button-color', theme.button_color || '#6b91e8');
};
    
  useEffect(() => {
      if (!/^\/login(?:\/)?$/.test(location.pathname)) {
        console.log("only /login");
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch]);

  useEffect(()=>{
    console.log(backButtonUrl);
    console.log(companyLogoUrl);
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])


  useEffect(() => {
    const body = document.body;
    if (themeStatus === 'succeeded' && themeData) {
      applyCustomTheme(themeData.colors);
      const bg = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      if (body.classList.contains('common-bg')) {
        body.style.backgroundImage = `url(${process.env.REACT_APP_S3_PATH + bg})`;
      }
    } else if (themeStatus === 'idle' || themeStatus === 'loading') {
      // clear any stale background left over from a previous theme/session
      // while the new theme is still loading
      body.style.backgroundImage = 'none';
    }
  }, [themeStatus, themeData]);

  // Game-only font selection. Admin never renders through this wrapper, so the
  // admin panel keeps the global FiraSans-Medium default. Invalid/missing
  // values safely fall back to the default.
  const GAME_FONTS = { 'FiraSans-Medium': 'FiraSans-Medium', 'Georama': 'Georama' };
  const DEFAULT_GAME_FONT = 'FiraSans-Medium';
  const selectedFont = GAME_FONTS[themeData?.font] || DEFAULT_GAME_FONT;

  // Logo should go to the same place as the platform back redirect:
  // user.backButtonRedirect already resolves to platformBackLink when the
  // login API provides it, otherwise the base URL.
  const logoRedirect = user?.backButtonRedirect || process.env.REACT_APP_BASE_URL;

  return (
    <div className="game-font-root" style={{ fontFamily: selectedFont }}>
      <header className="upperaction">
      <a href={logoRedirect}><img src={logoUrl} className="logo-holder" /></a>
        <div className="back-holder">
       <a href={backUrl}><button className="back-default">Back</button></a> 
        </div>
       
      </header>
      {children}
    </div>
  );
}

export default USER;
